import {
  IMPORT_REQUEST_STATUS,
  type EventStateImportHistoryResponse,
  type EventStateImportRequestItem,
} from './eventStateImportHistory.types';

import { KNOWLEDGE_API_URL } from '~/src/constants/env';

const API_BASE = KNOWLEDGE_API_URL;

type PaginationParams = {
  page: number;
  limit: number;
};

const MOCK_ITEMS: EventStateImportRequestItem[] = [
  {
    id: 'mock-in-progress',
    filePath: 'uploads/csv/event_state_corrected_in_progress.csv',
    importStatus: IMPORT_REQUEST_STATUS.IN_PROGRESS,
    importedAt: null,
    createdAt: '2026-04-20T10:15:17.421Z',
    errorReport: null,
  },
  {
    id: 'mock-succeeded',
    filePath: 'uploads/csv/event_state_corrected_success.csv',
    importStatus: IMPORT_REQUEST_STATUS.SUCCEEDED,
    importedAt: '2026-04-20T09:14:52.120Z',
    createdAt: '2026-04-20T09:14:31.002Z',
    errorReport: null,
  },
  {
    id: 'mock-failed',
    filePath: 'uploads/csv/event_state_corrected_failed.csv',
    importStatus: IMPORT_REQUEST_STATUS.FAILED,
    importedAt: '2026-04-20T08:07:02.533Z',
    createdAt: '2026-04-20T08:06:44.204Z',
    errorReport: 'Duplicate code "OPEN" found in header mapping.',
  },
];

export function buildMockEventStateImportHistoryResponse(
  params: PaginationParams,
): EventStateImportHistoryResponse {
  const start = (params.page - 1) * params.limit;
  const end = start + params.limit;
  const data = MOCK_ITEMS.slice(start, end);

  return {
    data,
    meta: {
      total: MOCK_ITEMS.length,
      page: params.page,
      limit: params.limit,
      totalPages: Math.max(1, Math.ceil(MOCK_ITEMS.length / params.limit)),
    },
  };
}

export async function getEventStateImportHistory(
  params: PaginationParams,
): Promise<EventStateImportHistoryResponse> {
  const searchParams = new URLSearchParams({
    page: String(params.page),
    limit: String(params.limit),
  });
  const response = await fetch(
    `${API_BASE}/api/v1/event-states/import-requests?${searchParams.toString()}`,
    {
      credentials: 'include',
    },
  );

  if (!response.ok) {
    throw new Error('Failed to fetch Event State import history');
  }

  return (await response.json()) as EventStateImportHistoryResponse;
}
